import toDate from '../to-date';

export const getTime = (date: Date | number): number => {
  const formattedDate = toDate(date);
  const timestamp = formattedDate.getTime();

  return timestamp;
};

export default getTime;
